import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../classes/base-component';
import { DownloadService } from '../../services/download.service';

@Component({
    selector: 'app-downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['./downloads.component.scss'],
})
export class DownloadsComponent extends BaseComponent implements OnInit {
    selectedMonth = '';
    availableMonths: Array<{ value: string; label: string }> = [];
    MONTHS: Array<string> = [];

    constructor(
        private title: Title,
        private translate: TranslateService,
        public downloadService: DownloadService
    ) {
        super();
    }

    ngOnInit() {
        this.title.setTitle('Meine Downloads | E.ON Smart Control');
        this.translate.get('screens.dashboard.months').subscribe((monthsList: string[]) => {
            this.MONTHS = monthsList;
            this.initializeAvailableMonths();
        });
        this.addSub(this.translate.onLangChange.subscribe(() => this.initializeAvailableMonths()));
    }

    private initializeAvailableMonths(): void {
        const currentDate = new Date();
        this.availableMonths = [];

        for (let i = 0; i <= 3; i++) {
            const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
            const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            const monthName = this.MONTHS[date.getMonth()];
            const label = `${monthName} ${date.getFullYear()}`;
            this.availableMonths.push({ value, label });
        }

        if (this.availableMonths.length > 0) {
            this.selectedMonth = this.availableMonths[0].value;
        }
    }

    private getPreviousMonth(): string {
        const currentDate = new Date();
        const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        const year = previousMonth.getFullYear();
        const month = String(previousMonth.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    }

    openEnergyReport() {
        this.downloadService.openEnergyReport(this.getPreviousMonth());
    }

    exportConsumptionData() {
        this.downloadService.exportConsumptionData(this.selectedMonth).subscribe();
    }

    exportToThirdParties() {
        this.downloadService.exportToThirdParties().subscribe();
    }

    exportGdprData() {
        this.downloadService.exportGdprData().subscribe();
    }
}
